import React from 'react'
import {BiTimeFive} from 'react-icons/bi'

const Jobcard = () => {
  return (
    <div>
      <div className=' jobContainer bg-white flex gap-10 justify-center flex-wrap items-center py-14'>
        <div className='transition-all duration-300  group group/item singleJob w-[250px] p-5 bg-white rounded-xl hover:bg-emerald-800 shadow-lg shadow-gray-600 hover:shadow-xl'>
            <span className='flex justify-between items-center gap-4'>
                <h1 className='text-[16px] font-semibold group-hover:text-white'>Web Developer</h1>
                <span className='flex items-center text-gray-400'>
                    <BiTimeFive/>Now
                </span>
            </span>
            <h6 className='text-gray-400'>Banglore</h6>
            <p className='text-sm text-gray-600 pt-5 border-t-2 mt-5 group-hover:text-white'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, necessitatibus.</p>
            <div className='company flex items-center gap-2 group-hover:text-white text-lg'>Amazon</div>
            <button className='border-2 rounded-xl block p-2.5 w-full text-lg font-semibold hover:bg-white group-hover/item:text-black'>
                Apply Now
            </button>

        </div>
        <div className='transition-all duration-300  group group/item singleJob w-[250px] p-5 bg-white rounded-xl hover:bg-emerald-800 shadow-lg shadow-gray-600 hover:shadow-xl'>
            <span className='flex justify-between items-center gap-4'>
                <h1 className='text-[16px] font-semibold group-hover:text-white'>Web Developer</h1>
                <span className='flex items-center text-gray-400'>
                    <BiTimeFive/>Now
                </span>
            </span>
            <h6 className='text-gray-400'>Banglore</h6>
            <p className='text-sm text-gray-600 pt-5 border-t-2 mt-5 group-hover:text-white'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, necessitatibus.</p>
            <div className='company flex items-center gap-2 group-hover:text-white text-lg'>Amazon</div>
            <button className='border-2 rounded-xl block p-2.5 w-full text-lg font-semibold hover:bg-white group-hover/item:text-black'>
                Apply Now
            </button>

        </div>
        <div className='transition-all duration-300  group group/item singleJob w-[250px] p-5 bg-white rounded-xl hover:bg-emerald-800 shadow-lg shadow-gray-600 hover:shadow-xl'>
            <span className='flex justify-between items-center gap-4'>
                <h1 className='text-[16px] font-semibold group-hover:text-white'>Web Developer</h1>
                <span className='flex items-center text-gray-400'>
                    <BiTimeFive/>Now
                </span>
            </span>
            <h6 className='text-gray-400'>Banglore</h6>
            <p className='text-sm text-gray-600 pt-5 border-t-2 mt-5 group-hover:text-white'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, necessitatibus.</p>
            <div className='company flex items-center gap-2 group-hover:text-white text-lg'>Amazon</div>
            <button className='border-2 rounded-xl block p-2.5 w-full text-lg font-semibold hover:bg-white group-hover/item:text-black'>
                Apply Now
            </button>

        </div>
        <div className='transition-all duration-300  group group/item singleJob w-[250px] p-5 bg-white rounded-xl hover:bg-emerald-800 shadow-lg shadow-gray-600 hover:shadow-xl'>
            <span className='flex justify-between items-center gap-4'>
                <h1 className='text-[16px] font-semibold group-hover:text-white'>Web Developer</h1>
                <span className='flex items-center text-gray-400'>
                    <BiTimeFive/>Now
                </span>
            </span>
            <h6 className='text-gray-400'>Banglore</h6>
            <p className='text-sm text-gray-600 pt-5 border-t-2 mt-5 group-hover:text-white'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, necessitatibus.</p>
            <div className='company flex items-center gap-2 group-hover:text-white text-lg'>Amazon</div>
            <button className='border-2 rounded-xl block p-2.5 w-full text-lg font-semibold hover:bg-white group-hover/item:text-black'>
                Apply Now
            </button>

        </div>
        <div className='transition-all duration-300  group group/item singleJob w-[250px] p-5 bg-white rounded-xl hover:bg-emerald-800 shadow-lg shadow-gray-600 hover:shadow-xl'>
            <span className='flex justify-between items-center gap-4'>
                <h1 className='text-[16px] font-semibold group-hover:text-white'>Web Developer</h1>
                <span className='flex items-center text-gray-400'>
                    <BiTimeFive/>Now
                </span>
            </span>
            <h6 className='text-gray-400'>Banglore</h6>
            <p className='text-sm text-gray-600 pt-5 border-t-2 mt-5 group-hover:text-white'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, necessitatibus.</p>
            <div className='company flex items-center gap-2 group-hover:text-white text-lg'>Amazon</div>
            <button className='border-2 rounded-xl block p-2.5 w-full text-lg font-semibold hover:bg-white group-hover/item:text-black'>
                Apply Now
            </button>

        </div>
        <div className='transition-all duration-300  group group/item singleJob w-[250px] p-5 bg-white rounded-xl hover:bg-emerald-800 shadow-lg shadow-gray-600 hover:shadow-xl'>
            <span className='flex justify-between items-center gap-4'>
                <h1 className='text-[16px] font-semibold group-hover:text-white'>Web Developer</h1>
                <span className='flex items-center text-gray-400'>
                    <BiTimeFive/>Now
                </span>
            </span>
            <h6 className='text-gray-400'>Banglore</h6>
            <p className='text-sm text-gray-600 pt-5 border-t-2 mt-5 group-hover:text-white'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus, necessitatibus.</p>
            <div className='company flex items-center gap-2 group-hover:text-white text-lg'>Amazon</div>
            <button className='border-2 rounded-xl block p-2.5 w-full text-lg font-semibold hover:bg-white group-hover/item:text-black'>
                Apply Now
            </button>

        </div>
        
      </div>
    </div>
  )
}

export default Jobcard
